var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _g3, _path16, _path17, _ellipse, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g4, _path26, _path27, _path28, _g5, _g6, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayaccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "payaccess",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 328,
    height: 240,
    viewBox: "0 0 328 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cea600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b4926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e7145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.001,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.001,
    y1: 0.499,
    x2: 0.999,
    y2: 0.499,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13190",
    "data-name": "Path 13190",
    d: "M3503.829,1153.5c68.653-34.753,127.436-18.275,150.789,14.682,6.38,8.981,19.18,27.1,11.075,57.283-15.609,57.947-98.948,124.758-167.562,143.11-8.827,2.382-68.653,17.532-98.105-15.111-21.587-23.9-14.766-60.056-13.883-64.507,1.124-5.623,4.213-18.587,12.679-35.26C3418.684,1214.456,3460.936,1175.213,3503.829,1153.5Z",
    transform: "translate(-3354.221 -1134.157)",
    fill: "#e2e2e2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11342",
    "data-name": "Group 11342",
    transform: "translate(305.277 155.303) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13191",
    "data-name": "Path 13191",
    d: "M0,11.132C0,3.105,6.729-1.23,14.97,2.168,22.833,5.39,25.177.059,31.981,0,39.239-.058,40.3,8.085,45.666,5.156c10.358-5.566,19.279.059,15.045,8.436-3.4,6.737-8.543,7.968-12.777,7.733-7.636-.41-6.5,5.331-15.424,4.98-11.416-.41-7.258-9.022-17.616-7.792C8.468,19.334,0,15.408,0,11.132Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13192",
    "data-name": "Path 13192",
    d: "M3483.923,1216.82c7.823,0,23.829,13.841.923,16.047s-57.248,1.2-71.128,1.244c-22.666.08-28.282-.843-28.122-10.109.121-5.376,3.009-8.826,14.964-10.23,12.437-1.444,6.1-15.285,21.262-14.884,12.918.361,14.242,18.454,26.077,14.041,11.834-4.453,9.347,7.662,18.012,9.869C3475.418,1225.244,3476.14,1216.82,3483.923,1216.82Z",
    transform: "translate(-3354.917 -1172.914)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13193",
    "data-name": "Path 13193",
    d: "M4126.4,1253.04h0a.142.142,0,0,0,.081-.04C4126.48,1253.04,4126.4,1253.04,4126.4,1253.04Z",
    transform: "translate(-3798.48 -1205.323)",
    fill: "#1f1f39",
    opacity: 0.46
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13194",
    "data-name": "Path 13194",
    d: "M3641.529,1403.1c-9.668,3.731-14.483,5.857-15.927,6.539-8.545,3.972,4.173,25.234,9.147,23.268,7.943-3.129,22.064-9.147,22.064-9.147Z",
    transform: "translate(-3496.895 -1298.481)",
    fill: "#6a75b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13195",
    "data-name": "Path 13195",
    d: "M3822.5,1251.725a141.006,141.006,0,0,1-28.4,29.085q-3.009,2.347-6.258,4.573a143.182,143.182,0,0,1-17.933,10.551c-33.819,16.488-76.1,26.919-87.616,30.81-3.37,1.123-7.1-.361-10.631-3.37-11.233-9.468-20.861-33.979-12.436-38.794,6.94-3.972,49.144-41.722,79.272-54.8a120.514,120.514,0,0,1,30.008-8.1c29.326-4.293,59.454-.281,62.864,7.261C3833.052,1232.789,3829.762,1241.495,3822.5,1251.725Z",
    transform: "translate(-3516.806 -1185.514)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13196",
    "data-name": "Path 13196",
    d: "M3732.5,1460.465c-1.083,1.244-2.167,2.487-3.25,3.771-12.677,15-24.953,32.094-32.535,26.156-3.089-2.407-3.771-6.78-3.37-11.233a50.27,50.27,0,0,1,2.848-12.156c.321-.842.6-1.564.8-2.086a7.166,7.166,0,0,1,.361-.843.309.309,0,0,0,.04-.12.441.441,0,0,1,.16-.08c2.648-1,36.868-13.961,37.389-10.671h0a7.836,7.836,0,0,1-.6,3.972A15.514,15.514,0,0,1,3732.5,1460.465Z",
    transform: "translate(-3539.117 -1328.936)",
    fill: "#ff9100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13197",
    "data-name": "Path 13197",
    d: "M3693.7,1400.447s-28.524,30.048-36.587,32.415-1.564-15,3.29-17.772S3699.555,1394.389,3693.7,1400.447Z",
    transform: "translate(-3515.203 -1296.161)",
    fill: "#ff9100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13198",
    "data-name": "Path 13198",
    d: "M3629.719,1356.735a7.8,7.8,0,0,1-2.568.642c-8.866.842-22.185-10.19-18.494-15.044,4.092-5.336,25.033-5.3,44.45-6.178,2.527-.12,4.052.12,4.814.642C3662.415,1340.046,3637.021,1353.485,3629.719,1356.735Z",
    transform: "translate(-3488.095 -1257.464)",
    fill: "#ff9100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13199",
    "data-name": "Path 13199",
    d: "M3961.548,1280.75c-22.1-12.6-27.079-43.928-25.675-59.173,29.326-4.292,59.454-.281,62.864,7.261C4002.067,1236.26,3987.223,1260.972,3961.548,1280.75Z",
    transform: "translate(-3684.257 -1185.454)",
    fill: "#6a75b9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13200",
    "data-name": "Path 13200",
    d: "M3428.227,1444.041c-15,1.846-29.687,3.169-42.6,7.382-12.878,4.212-29.807-16.328-27.761-10.029,2.046,6.259,8.666,13.159,5.737,14.242s-30.249-9.187-26.117-2.728,20.861,16.087,9.067,15.846-50.508,31.934-32.9,32.214c6.058.08,25.354,20.259,53.156,4.252s32.656-18.534,31.251-13.68,1.524,18.414,9.789-2.046,19.1-34.822,18.494-27.32,4.011,1.765,6.98-5.576C3435.328,1451.623,3433.241,1443.439,3428.227,1444.041Z",
    transform: "translate(-3309.131 -1322.015)",
    fill: "url(#linear-gradient)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13201",
    "data-name": "Path 13201",
    d: "M3845.842,1299.2a141,141,0,0,1-28.4,29.085q-3.009,2.347-6.258,4.573a143.241,143.241,0,0,1-17.933,10.551c-33.819,16.488-76.1,26.919-87.616,30.81-3.37,1.123-7.1-.361-10.631-3.37C3712.571,1364.19,3810.859,1327.844,3845.842,1299.2Z",
    transform: "translate(-3540.147 -1235.532)",
    fill: "#1f1f39",
    opacity: 0.28
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13202",
    "data-name": "Path 13202",
    d: "M3453.988,1475.727c-5.657,1-13.76,3.009-17.692,1.966-7.742-2.086-3.33,3.249-1.083,4.734s-29.165-.762-23.91,3.29c2.487,1.885,5.135,1.163-3.41,5.857-14.2,7.743-22.506,15.164-13.8,15.566s25.154,6.339,37.39-2.728,23.669-17.411,22.305-13.921-2.969,6.539,3.169.281c6.178-6.258,16.007-17.01,9.548-18.253C3460.085,1471.234,3457.076,1475.165,3453.988,1475.727Z",
    transform: "translate(-3357.878 -1340.881)",
    fill: "#f25344"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11346",
    "data-name": "Group 11346",
    transform: "translate(44.548 149.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11343",
    "data-name": "Group 11343",
    transform: "translate(0 14.041)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    y1: 50.147,
    x2: 81.077,
    transform: "translate(0.813 0.822)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13203",
    "data-name": "Path 13203",
    d: "M3502.746,1559.531a.562.562,0,0,1,.12.16c.16.361-.081.883-.12.481l-81.077,50.147c-.8.923-1.284.842-1.444.481a.985.985,0,0,1,.481-1.123l81.077-50.147A.725.725,0,0,1,3502.746,1559.531Z",
    transform: "translate(-3420.175 -1559.35)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11344",
    "data-name": "Group 11344",
    transform: "translate(40.88 26.357)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    y1: 18.775,
    x2: 30.329,
    transform: "translate(0.813 0.822)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13204",
    "data-name": "Path 13204",
    d: "M3553.9,1590.231a.557.557,0,0,1,.12.16.986.986,0,0,1-.481,1.123l-30.369,18.775c-.441.281-.883.2-1.043-.16a.986.986,0,0,1,.481-1.123l30.369-18.775A.676.676,0,0,1,3553.9,1590.231Z",
    transform: "translate(-3522.075 -1590.05)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11345",
    "data-name": "Group 11345",
    transform: "translate(55.884)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    y1: 18.775,
    x2: 30.329,
    transform: "translate(0.812 0.822)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13205",
    "data-name": "Path 13205",
    d: "M3591.3,1524.531a.556.556,0,0,1,.121.161.986.986,0,0,1-.481,1.123l-30.369,18.775c-.441.281-.883.2-1.043-.161a.986.986,0,0,1,.481-1.123l30.369-18.775A.676.676,0,0,1,3591.3,1524.531Z",
    transform: "translate(-3559.475 -1524.35)",
    fill: "url(#linear-gradient-7)"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13206",
    "data-name": "Path 13206",
    d: "M3739.353,1453.2c-10.029,4.012-31.693,12-38.753,13.76.562-1.565,1-2.648,1.163-2.969a.857.857,0,0,0,.2-.161c2.648-.963,36.868-13.921,37.39-10.631Z",
    transform: "translate(-3543.524 -1328.507)",
    fill: "#1f1f39",
    opacity: 0.28
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13207",
    "data-name": "Path 13207",
    d: "M3729.249,1481.6c-12.677,15-24.953,32.094-32.535,26.157-3.089-2.407-3.771-6.78-3.37-11.233,2.046.361,4.453.762,7.1,1.284C3708.308,1499.252,3716.893,1489.864,3729.249,1481.6Z",
    transform: "translate(-3539.118 -1346.395)",
    fill: "#1f1f39",
    opacity: 0.16
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13208",
    "data-name": "Path 13208",
    d: "M3658.268,1357.8a7.794,7.794,0,0,1-2.568.642c6.259-5.937,19.5-15.164,30.73-20.54C3690.963,1341.109,3665.569,1354.549,3658.268,1357.8Z",
    transform: "translate(-3516.641 -1258.541)",
    fill: "#1f1f39",
    opacity: 0.16
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11347",
    "data-name": "Group 11347",
    transform: "translate(259.92 43.683)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13209",
    "data-name": "Path 13209",
    d: "M4049.3,1246.735c3.209-.361,8.545,1.6,8.385,2.768",
    transform: "translate(-4012.231 -1245.228)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 23.907
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13210",
    "data-name": "Path 13210",
    d: "M3956.9,1245.635c7.221-1.805,22.706-3.37,28.885-2.166",
    transform: "translate(-3956.9 -1243.045)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 23.907
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13211",
    "data-name": "Path 13211",
    d: "M3537.712,1384.526c-1.284-2.086-5.215-1.484-4.614,2.808s-1.885,4.654-2.688,5.175c-.8.481-3.731,2.969-.562,4.573,3.169,1.645,10.27-1.926,12.837.08s5.576.481,5.175-2.568-2.648-4.172-.843-6.539c1.805-2.407-1.083-9.347-3.45-6.98C3541.242,1383.443,3539.517,1387.415,3537.712,1384.526Z",
    transform: "translate(-3440.424 -1284.565)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13212",
    "data-name": "Path 13212",
    d: "M3468.369,1404.081c-1.525.281-2.126,3.932.6,3.37,2.206-.441,3.851.241,3.972.843.481,2.046,2.728,1.4,3.009-.562.361-2.207.8-3.731,2.567-4.774s1.564-3.169-.281-3.651c-1.885-.481-4.654,1.725-5.616.12s-4.894.4-4.052,2.327C3469.412,1403.72,3468.369,1404.081,3468.369,1404.081Z",
    transform: "translate(-3403.701 -1295.617)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_409",
    "data-name": "Ellipse 409",
    cx: 23.188,
    cy: 20.059,
    rx: 23.188,
    ry: 20.059,
    transform: "translate(194.129 64.618) rotate(-25.017)",
    fill: "#1f1f39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13213",
    "data-name": "Path 13213",
    d: "M3857.752,1301.67c-.16.481-.361.923-.561,1.4a17.369,17.369,0,0,1-6.339,7.141,20.193,20.193,0,0,1-2.247,1.244c-8.144,3.811-17.451,1.163-20.741-5.9a13.425,13.425,0,0,1,.642-12.156,17.708,17.708,0,0,1,8.144-7.5c7.422-3.45,15.806-1.6,19.738,4.092a13.285,13.285,0,0,1,1.043,1.805A12.928,12.928,0,0,1,3857.752,1301.67Z",
    transform: "translate(-3619.03 -1225.804)",
    fill: "#5c5c68"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13214",
    "data-name": "Path 13214",
    d: "M3857.491,1292.042a13.054,13.054,0,0,1,.361,9.909c-.161.481-.361.923-.562,1.4-.963-.04-2.006-.04-3.089,0h-4.573c-.481,0-.963.04-1.444.04h-.481c-.481,0-.923.04-1.364.04h-.321a1.662,1.662,0,0,0-.361-.12h0c.04.04.04.08.081.12a56.915,56.915,0,0,0,5.215,6.94,20.172,20.172,0,0,1-2.247,1.244c-8.144,3.811-17.451,1.163-20.74-5.9a13.424,13.424,0,0,1,.642-12.155c5.536-3.29,14.041-7.663,14.041-7.663l1.845-1.2c2.528,1.123,6.94,3.089,11.955,5.456C3856.85,1290.838,3857.17,1291.44,3857.491,1292.042Z",
    transform: "translate(-3619.089 -1226.128)",
    fill: "#ff9100"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13215",
    "data-name": "Path 13215",
    d: "M3882.543,1324.746c-.16.481-.361.922-.562,1.4-.963-.04-2.006-.04-3.089,0h-4.573c-.481,0-.963.04-1.444.04h-.481c-.481,0-.923.04-1.364.04a2.18,2.18,0,0,1-.682-.12h0l-2.246-3.41C3868.1,1322.78,3876.726,1323.221,3882.543,1324.746Z",
    transform: "translate(-3643.819 -1249.107)",
    fill: "#1f1f39",
    opacity: 0.64
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13216",
    "data-name": "Path 13216",
    d: "M3824.212,1320.859c3.731-3.33,7.462-7.3,7.181-13.158l-11.193,4.333v.04A23.711,23.711,0,0,0,3824.212,1320.859Z",
    transform: "translate(-3615.138 -1240.04)",
    fill: "#1f1f39",
    opacity: 0.48
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13217",
    "data-name": "Path 13217",
    d: "M3894.988,1151.924c-1.244-1.324-3.209-4.413-3.209-5.336s.241-2.728.241-2.728-.762-1.284-2.768-.521-3.169,2.086-3.25,3.249c-.08,1.6-.4,2.969,1.685,4.132,1.926,1.083,3.531,4.292,3.531,4.292Z",
    transform: "translate(-3654.499 -1139.511)",
    fill: "#f5b1b4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13218",
    "data-name": "Path 13218",
    d: "M3893.682,1144.255c1.444,1.284,1.525,2.247-.6,3.009-2.166.762-3.129.241-4.212-1.6-1.043-1.846,3.49-1.966,3.731-1.886A7.5,7.5,0,0,1,3893.682,1144.255Z",
    transform: "translate(-3656.161 -1139.905)",
    fill: "#f5b1b4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13219",
    "data-name": "Path 13219",
    d: "M3834.27,1187.219l-5.1-1.805c.161-2.327-.8-7.9-.24-9.989.6-2.247.8-2.126.8-2.126l3.41,2.367,1.6,1.123a5.792,5.792,0,0,0,0,2.487,12.573,12.573,0,0,0,1.645,4.253C3837.158,1184.812,3834.27,1187.219,3834.27,1187.219Z",
    transform: "translate(-3620.262 -1157.595)",
    fill: "#efaea6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13220",
    "data-name": "Path 13220",
    d: "M3837.285,1180.323a7.9,7.9,0,0,0,.04,2.728c-3.37,1.2-5.055-1.324-4.172-2.166a24.248,24.248,0,0,1,2.528-1.685Z",
    transform: "translate(-3622.756 -1161.13)",
    fill: "#1f1f39",
    opacity: 0.14
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11348",
    "data-name": "Group 11348",
    transform: "translate(203.804 6.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13221",
    "data-name": "Path 13221",
    d: "M3833.284,1161c.361,1.926,2.969,5.376,1.6,5.536s.8,4.052-.6,4.252c-3.45.522-7.7-1.163-8.3-2.768-.642-1.564-.882-6.178-.882-6.178Z",
    transform: "translate(-3821.877 -1156.477)",
    fill: "#efaea6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13222",
    "data-name": "Path 13222",
    d: "M3825.1,1156.494c1.123,0,1.164.241,1.886-.2s-.722-1.324.682-1.725,2.969-.642,2.929-2.287c-.04-2.327-2.086-1.725-3.37-1.324-.8.281-1.2-1.484-2.888-1.2-1.284.2-1.083.923-2.206,1.163-.682.161-2.207-.842-3.209.12-1.885,1.765.04,3.45-1.485,5.3-1.765,2.126,3.25,5.656,3.731,5.135.562-.642-.562-2.527,0-3.049.883-.8,1.083-.04,1.966.6.923.682,2.487.562,1.324-.843C3823.338,1156.815,3824.1,1156.494,3825.1,1156.494Z",
    transform: "translate(-3817.066 -1149.724)",
    fill: "#1f1f39"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13223",
    "data-name": "Path 13223",
    d: "M3822.81,1189.38c2.006-.963,3.45,1.364,5.175,1.124,1.043-.161.843-1.083,1.2-1.645.241-.361.842-.24,1.685-.361,2.206-.281,12.315,37.871,12.315,37.871s-3.53,6.379-7.7,7.943c-4.654,1.725-13.4,5.456-13.56,3.932s-2.728-45.814-2.728-45.814A12.542,12.542,0,0,1,3822.81,1189.38Z",
    transform: "translate(-3614.538 -1166.697)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13224",
    "data-name": "Path 13224",
    d: "M3778.539,1332.559c-.361,3.571.6,5.376-2.648,10.792-1.124,1.845-1.444,3.851,1.484,2.407s3.731-4.774,5.456-3.691c1.4.843,2.648,1.444,1.845-.522s-1.043-6.138-1-7.662C3783.714,1331.717,3778.539,1332.559,3778.539,1332.559Z",
    transform: "translate(-3588.124 -1255.115)",
    fill: "#f5b1b4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13225",
    "data-name": "Path 13225",
    d: "M3848,1172.835c9.187-.361,18.935,5.777,23.027,7.1.8-1.685-2.728-7.422-4.814-15.405,1.6-1.725,5.657-2.808,6.3-1.966.762,4.894,13.4,26.919,1.2,26.4-5.456-.241-14.2-4.694-16.529-2.688-1.484,1.284.963,11.875,1.926,14.563s4.774,7.743,4.253,9.989c-1.565,7.02-4.774,6.1-5.9,4.694-1.043-1.284-3.29-12.4-4.573-19.5s-.2-7.823-2.407-15.525",
    transform: "translate(-3631.782 -1150.994)",
    fill: "#6a75b9"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11349",
    "data-name": "Group 11349",
    transform: "translate(186.699 22.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13226",
    "data-name": "Path 13226",
    d: "M3799.732,1211.561c3.089,6.018,5.135,9.187,5.737,12.437.562,3.209,2.046,12.6-.561,15s-8.384,5.456-10.952,5.376c-1.725-.04-1.885-4.012-1.364-7.261.4-2.648-2.487-9.869-2.928-14.643a17.077,17.077,0,0,0-.441-2.608c-.16-.522-.361-1-.562-1.524-.882-2.287-1.966-4.533-2.206-5.536h0a1,1,0,0,1-.04-.321v-.04c-.843.722-4.614,12.356-4.253,16.649.522,6.579,1.364,17.772,2.207,20.139,1.043,3.049-5.857,2.688-6.98,2.126-1.163-.562-2.046-16.488-2.768-22.225-1.123-8.986,2.888-21.7,9.026-28.724,3.651-4.172,12.075-9.508,12.075-9.508C3796.363,1193.227,3795.841,1204.059,3799.732,1211.561Z",
    transform: "translate(-3774.431 -1190.9)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13227",
    "data-name": "Path 13227",
    d: "M3804.2,1240.547l.08.441h0c.281,1.043,1.323,3.21,2.166,5.456.2.522.4,1,.562,1.525a11.138,11.138,0,0,1,.441,2.608c.08.923.441,1.926.521,3.049.08-.2-.08-.361.04-.642.441-1.324.361-13-.4-15.285A15.126,15.126,0,0,0,3804.2,1240.547Z",
    transform: "translate(-3792.257 -1218.924)",
    fill: "#6a75b9",
    opacity: 0.28
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11350",
    "data-name": "Group 11350",
    transform: "translate(156.548 23.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13228",
    "data-name": "Path 13228",
    d: "M3814.491,1197.239c-.2-.12-2.006,4.092-4.694,5.656a6.641,6.641,0,0,1-2.407.843c-2.527.321-6.98-.04-10.19-.2a43.362,43.362,0,0,1,3.571-3.651c2.367.562,4.854,1.525,6.138,1.284a8.593,8.593,0,0,0,2.688-.963,16.719,16.719,0,0,0,3.851-2.929c.481-.481.521-1.2,1.163-1.284C3815.494,1195.915,3814.772,1197.4,3814.491,1197.239Z",
    transform: "translate(-3757.917 -1194.304)",
    opacity: 0.18,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13229",
    "data-name": "Path 13229",
    d: "M3757.137,1192.874a1.26,1.26,0,0,0-1.4-1.083c-.723.08-.762.361-1.324.963-1.725,1.725-4.292,3.851-7.462,4.453-3.209.562-10.832-3.169-15.525-1.805s-5.817,5.777-12.637,7.382c-6.779,1.565-14.4-.843-16.408-.361s-3.21,1.043-3.089,1.846a4.06,4.06,0,0,0,2.688,2.567c1.485.481,14.082.481,17.371-.2,5.376-1.123,9.668-6.338,13.118-6.9s10.952.963,15,.441c4.533-.562,7.863-6.178,8.184-6.018a1.136,1.136,0,0,0,1.163.161C3757.217,1194.118,3757.177,1193.315,3757.137,1192.874Z",
    transform: "translate(-3699.279 -1191.785)",
    fill: "#ff9100"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13230",
    "data-name": "Path 13230",
    d: "M3887.873,1158.548c-.522-.481-1.2-1.645-.562-1.765a4.111,4.111,0,0,1,2.487,1.244C3890.2,1158.508,3887.873,1158.548,3887.873,1158.548Z",
    transform: "translate(-3655.167 -1147.7)",
    fill: "#f5b1b4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13231",
    "data-name": "Path 13231",
    d: "M3689.28,1629.192a131.914,131.914,0,0,1-38.432-3.169c-1.966-.441-4.052-1.043-5.376-2.688-2.006-2.487-1.4-6.7.762-9.067s5.456-3.049,8.5-2.728c1.926.2,3.931.762,5.817.2,2.327-.762,3.892-3.089,5.457-5.135s3.69-4.092,6.1-3.771c1.805.241,3.25,1.725,4.855,2.688,1.6.923,3.971,1.043,4.894-.682,1.966-3.691-.8-13.841,9.387-13.841,14.723,0,12.316,10.23,14.081,12.4,2.688,3.29,7.462,2.568,11.354,1.444s8.5-2.166,11.514.762c2.608,2.568,2.888,7.221,5.656,9.548,2.929,2.487,7.141,1.163,10.711.04s8.184-1.524,10.23,1.845c1.725,2.848.441,6.94-2.046,9.026s-5.737,2.568-8.826,2.808C3723.781,1630.195,3705.448,1628.108,3689.28,1629.192Z",
    transform: "translate(-3509.775 -1414.3)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayaccess);
export default __webpack_public_path__ + "static/media/payaccess.31e262dcbb77ca6d3ab76df7645cd136.svg";
export { ForwardRef as ReactComponent };